(function () {
  function getShopifyLocale() {
    return (
      document.documentElement.lang ||
      window.Shopify?.locale ||
      'fr'
    ).slice(0, 2).toLowerCase();
  }

  const smileTitles = {
    fr: 'Comment cumuler les points',
    en: 'How to earn points',
    it: 'Il tuo status',
    de: 'So verdienen Sie Punkte'
  };

  function injectSmileCss() {
    const iframe = document.querySelector('.smile-panel-frame');

    if (!iframe) return;

    try {
      const doc = iframe.contentDocument || iframe.contentWindow.document;

      if (!doc || !doc.head) return;

      if (doc.getElementById('smile-custom-css')) return;

      const locale = getShopifyLocale();
      const customTitle = smileTitles[locale] || smileTitles.fr;

      const freeShippingTexts = {
        fr: 'Cliquez sur le bouton ci-dessous pour bénéficier de la livraison offerte, qui sera visible au check-out.',
        en: 'Click the button below to enjoy complimentary shipping, which will be applied and visible at checkout.',
        de: 'Klicken Sie auf die Schaltfläche unten, um von der kostenlosen Lieferung zu profitieren. Diese wird im Checkout angezeigt.',
        it: 'Clicca sul pulsante qui sotto per beneficiare della spedizione offerta, che sarà visibile al momento del checkout.'
      };

      const freeShippingGifts = {
        fr: 'Ajouter ce cadeau à votre commande pour tout achat à partir de 50€.',
        en: 'Kindly add this gift to your cart for any order above 50€.',
        de: 'Bitte legen Sie dieses Geschenk ab 50€ Bestellwert in den Warenkorb.',
        it: 'Aggiungete questo regalo al vostro ordine per ogni acquisto a partire da 50€.'
      };

      const freeShippingText = freeShippingTexts[locale] || freeShippingTexts.fr;
      const freeShippingGift = freeShippingGifts[locale] || freeShippingGifts.fr;

      const style = doc.createElement('style');

      style.id = 'smile-custom-css';

      style.textContent = `
        .header-secondary,
        .header-primary,
        .heading,
        .body-1,
        .smile-button-border-radius-square .btn,
        .card-description,
        .list-item-title,
        .list-item-subtitle,
        .text-truncate,
        .text-muted,
        .points-balance {
          font-family: Helvetica, Arial, sans-serif !important;
        }

        .btn {
          text-transform: uppercase !important;
          color: white !important;
          background-color: #454545 !important;
          padding: 10px 32px !important;
          font-size: 13px !important;
        }

        .btn:hover {
          color: white !important;
          background-color: #454545 !important;
          border: 1px solid #454545;
        }

        .points-explainer-card-container .card-list-item-container:last-of-type,
        .points-summary-card-loaded .card-list-item-container:last-of-type {
          display: none !important;
        }

        .points-explainer-card-container .card-list-item-container:first-of-type {
          /*font-size: 0 !important;*/
        }

        .points-explainer-card-container .card-list-item-container:first-of-type::after {
          /*content: "${customTitle}";
          font-size: 14px !important;
          font-family: Helvetica, Arial, sans-serif !important;*/
        }
        .reward-fulfillment-card .card-description span {
          font-size: 0 !important;
          margin-top:0px !important;
          margin-bottom:0px !important;
          padding-top:0px !important;
          padding-bottom:0px !important;
          height: 0px !important;
        }
        .header-primary {font-size:32px !important;}
        div[aria-label="Livraison Offerte"]:after {
          content: "${freeShippingText}";
          display: block;
          font-size: 12px !important;
          line-height: 1.5;
          margin-top:8px !important;
        }
        div[aria-label="Bougie Éd. Limitée 700g Offerte"]:after,
        div[aria-label="Bougie 230g Offerte"]:after,
        div[aria-label="Coffret Découverte Offert"]:after,
        div[aria-label="Carnet Parfumé Offert"]:after,
        div[aria-label="Échantillon Bestseller"]:after,
        div[aria-label="Échantillon Nouveauté"]:after {
          content: "${freeShippingGift}";
          display: block;
          font-size: 12px !important;
          line-height: 1.5;
          margin-top: 8px !important;
        }
        div[aria-label="Livraison Offerte"],
        div[aria-label="Bougie Éd. Limitée 700g Offerte"],
        div[aria-label="Bougie 230g Offerte"],
        div[aria-label="Coffret Découverte Offert"],
        div[aria-label="Carnet Parfumé Offert"],
        div[aria-label="Échantillon Bestseller"],
        div[aria-label="Échantillon Nouveauté"] {
          display:block !important;
        }
      `;

      doc.head.appendChild(style);

      console.log('Smile CSS injected', locale);

    } catch (e) {
      console.log('Smile iframe inaccessible', e);
    }
  }

  const observer = new MutationObserver(() => {
    injectSmileCss();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener('click', () => {
    setTimeout(injectSmileCss, 250);
    setTimeout(injectSmileCss, 1000);
  });

  injectSmileCss();
})();